<template>
  <a-modal :bodyStyle="customStyle"
           :centered="true"
           :mask="true"
           :maskClosable="false"
           :title="title"
           :visible="visible"
           :width="`${modalWidth*0.85}px`"
           class="modal-content"
           @cancel="close">
    <div slot="footer">
      <a-button-group style="float: left">
        <a-button v-if="disableSubmit" :disableSubmit="disableSubmit" icon="download" @click="exportDetailExcel('直营收货单明细')">导出</a-button>
        <go-barcode-import-button :barcodeListReady="barcodeListReady && billDetailsReady" :disableSubmit="disableSubmit" :getPrice="handleGetPrice" :loading="loading" @orderImport="handleOrderImport"/>
        <go-print v-if="disableSubmit" :id="form.id" :disabled="loading" orderType="DeptSaleInput"/>
        <a-dropdown v-if="disableSubmit">
          <a-menu slot="overlay">
            <a-menu-item :key="1" @click="pushExternal">
              <a-icon type="caret-right"/>
              推送同步
            </a-menu-item>
          </a-menu>
          <a-button :disabled="loading" icon="down">其他操作</a-button>
        </a-dropdown>
      </a-button-group>
      <BarcodeCheckButton
        v-if="disableSubmit"
        :form="form"
        :loading="loading"
        :type="2"
        :visible="visible"
        :warehouseId="form.warehouseId"
        buttonUrl="/bill/wmsButton/saleInput"
        style="margin-right: 8px;"
        @barcodeVerify="handleBarcodeVerify"
        @checkState="getCheckState"
        @pushWms="handlePushToWms(form.id)"/>
      <a-space size="small">
        <a-button :disabled="loading" @click="close">关闭</a-button>
        <a-button v-if="disableSubmit && !form.submitFlag && !form.cancelFlag" v-has="'DeptSaleInput:edit'" :disabled="loading" @click="handleUpdate">修改</a-button>
        <a-button v-if="!disableSubmit" :disabled="loading" type="primary" @click="handleOk">保存</a-button>
        <a-popconfirm v-has="'DeptSaleInput:delete'" title="确定删除该条记录?" @confirm="() => handleDelete(form.id)">
          <a-button v-if="disableSubmit && !form.submitFlag" :disabled="loading" type="danger">删除</a-button>
        </a-popconfirm>
        <a-popconfirm title="确定提交审核?" @confirm="() => handleSubmit(form.id)">
          <a-button v-if="disableSubmit && !form.submitFlag && !form.cancelFlag" v-has="'DeptSaleInput:edit'" :disabled="loading" type="primary">提交</a-button>
        </a-popconfirm>
        <a-popconfirm v-if="disableSubmit && form.submitFlag && !form.auditFlag && !form.instanceId && !form.cancelFlag" v-has="'DeptSaleInput:unSubmit'"
                      title="确定取消提交?"
                      @confirm="() => handleUnSubmit(form.id)">
          <a-button :disabled="loading">取消提交</a-button>
        </a-popconfirm>
        <a-popconfirm title="确定审核该单据?" @confirm="() => handleAudit(form.id)">
          <a-button v-if="disableSubmit && form.submitFlag && !form.auditFlag && canNextStep && !form.cancelFlag" v-has="'DeptSaleInput:audit'" :disabled="loading" type="primary">审核</a-button>
        </a-popconfirm>
        <go-pop-confirm v-if="disableSubmit && form.auditFlag && !form.cancelFlag" v-has="'DeptSaleInput:cancel'" :disabled="loading" title="确定反冲该单据?" @confirm="() => handleCancel(form.id)">
          <a-button :disabled="loading" type="danger">红字反冲</a-button>
        </go-pop-confirm>
        <go-pop-confirm v-if="form.cancelFlag"
                        v-has="'DeptSaleInput:cancel'"
                        :disabled="loading"
                        title="确定恢复该单据?"
                        @confirm="() => handleReEdit(form.id)">
          <a-button :disabled="loading" type="danger">恢复编辑</a-button>
        </go-pop-confirm>
      </a-space>
    </div>
    <a-spin ref="content" :spinning="loading" tabindex="-1">
      <a-form-model ref="form" :model="form" :rules="rules" class="vertical-form" @validate="handleValidate">
        <a-col :span="20" style="padding: 12px 12px 1px 12px;">
          <a-row :gutter="4" justify="start">
            <a-col :span="6">
              <a-form-model-item :label="fieldLabel('id')" info="出货单号" prop="id">
                <a-input v-model="form.id" :disabled="true" autocomplete="off" placeholder="规则自动生成"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="fieldLabel('invoicedate')" info="出货日期" prop="invoicedate">
                <a-date-picker v-model="form.invoicedate" :disabled="disableSubmit"
                               format="YYYY-MM-DD" style="width: 100%" valueFormat="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('handNo')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('handNo')" info="手工单号" prop="handNo">
                <a-input v-model="form.handNo" :disabled="disableSubmit" autocomplete="off"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('priceType')" :span="6" class="form-field" type="select" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('priceType')" info="价格类型" prop="priceType">
                <j-select v-model="form.priceType" :disabled="disableSubmit" dict-code="All_SaleOrder_Type"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('organizationId')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('organizationId')" info="收货渠道" prop="organizationId">
                <select-organization v-model="form.organizationId" :disabled="true" autocomplete="off" triggerChange @change="handleChangeOrderOrg"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('warehouseId')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('warehouseId')" info="收货仓库" prop="warehouseId">
                <select-warehouse v-model="form.warehouseId" :disabled="disableSubmit" :queryParam="queryWarehouseParam" autocomplete="off"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('sendOrganizationId')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('sendOrganizationId')" info="发货渠道" prop="sendOrganizationId">
                <select-organization v-model="form.sendOrganizationId" :disabled="true" autocomplete="off"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('saleOrderId')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('saleOrderId')" info="订货单" prop="saleOrderId">
                <select-sale-order v-model="form.saleOrderId" :disabled="true"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('saleNoticeId')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('saleNoticeId')" info="配货单" prop="saleNoticeId">
                <select-sale-notice v-model="form.saleNoticeId" :disabled="true"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('saleOutputId')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('saleOutputId')" info="出货单" prop="saleOutputId">
                <select-sale-output v-model="form.saleOutputId" :disabled="true"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="fieldVisible('memo')" :span="6" class="form-field" type="text" @keydown.enter="nextFocus">
              <a-form-model-item :label="fieldLabel('memo')" info="备注" prop="memo">
                <a-input v-model="form.memo" :disabled="disableSubmit" autocomplete="off"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="24">
          <a-tabs v-model="activeTab">
            <a-tab-pane key="1" style="padding: 4px 12px 1px 12px;" tab="商品列表">
              <a-row :gutter="2" justify="start">
                <a-col :span="12">
                  <go-edit-table ref="goodsTable"
                                 :columns="newGoodsColumns"
                                 :dataSource="goodsList"
                                 :edit="!disableSubmit"
                                 :height="bottomHeight"
                                 :showCheck="false"
                                 showSum
                                 tableKey="10145"
                                 @change="handleTableChange"
                                 @click="handleClickRow"
                                 @recordChange="handleRecordChange"
                                 @selectColumn="handleSelectColumn">
                    <template slot="goodsId" slot-scope="{text, record, index}">
                      <select-goods ref="goodsId"
                                    :disabled="!(record.editable && !disableSubmit)"
                                    :index="index"
                                    :initLabel="`[${record.goodsNo}]${record.goodsName}`"
                                    :value="text"
                                    class="only-bottom super-link"
                                    field="goodsId"
                                    style="display: inline-block;width: 100%;"
                                    triggerChange
                                    @change="(result) => handleChangeGoods(result, record, 'goodsId')"/>
                    </template>
                    <template slot="actions">
                      <a-button-group style="margin-left: 12px;">
                        <a-button v-if="!disableSubmit" size="small" @click="handleRemoveGoods">
                          <a-icon type="minus"/>
                          删行
                        </a-button>
                        <a-button :disabled="loading" icon="retweet" size="small" @click="exchangeShowDetail">
                          切换展示
                        </a-button>
                      </a-button-group>
                    </template>
                  </go-edit-table>
                </a-col>
                <a-col :span="12">
                  <order-qty-table
                    ref="qtyTable"
                    :canEdit="checkPermission('DeptSaleInput:editDetail')"
                    :detail="currentDetail"
                    :disabled="disableSubmit"
                    :height="bottomHeight"
                    @editGoods="handleUpdateGoods">
                  </order-qty-table>
                </a-col>
                <a-col v-if="!disableSubmit" v-has="'DeptSaleInput:editDetail'" :span="24">
                  <a-card :bordered="false" size="small">
                    <add-goods-tool-bar ref="goodsToolBar"
                                        :goodsList="goodsList"
                                        @ok="handleAddDetail"
                                        @selectGoods="handleSelectGoods"
                                        @updateGoods="handleUpdateGoods">
                    </add-goods-tool-bar>
                  </a-card>
                </a-col>
              </a-row>
            </a-tab-pane>
            <a-tab-pane v-if="disableSubmit" key="4" style="padding: 4px 12px 1px 12px;" tab="扫描记录">
              <go-edit-table ref="barcodeTable" :columns="uniBarcodeColumns"
                             :dataSource="uniBarcodeList"
                             :edit="!disableSubmit"
                             :height="bottomHeight"
                             :showCheck="false"
                             showSum
                             tableKey="10152">
              </go-edit-table>
            </a-tab-pane>
            <a-tab-pane key="2" :forceRender="true" style="padding: 4px 12px 1px 12px;" tab="附加信息">
              <a-col :span="24" style="padding: 12px 12px 1px 12px;">
              </a-col>
            </a-tab-pane>
            <a-tab-pane v-if="disableSubmit" key="3" style="padding: 4px 12px 1px 12px;" tab="单据状态">
              <a-col :span="24" style="padding: 12px 12px 1px 12px;">
                <bill-state v-if="activeTab==='3'" :form="form" orderType="deptSaleInput"/>
              </a-col>
            </a-tab-pane>
            <a-tab-pane key="100" style="padding: 1px 12px 1px 12px;" tab="接口推送日志" v-if="form.id">
              <api-log-list module-key="SaleInput" :recordId="form.id"/>
            </a-tab-pane>
          </a-tabs>
        </a-col>
        <dept-sale-input-input-qty-modal ref="inputQtyModal" @add="qtyCallBackAdd" @update="qtyCallBackUpdate"/>
        <bill-detail-modal ref="detailModal"/>
        <warehouse-in-barcode-verify-modal ref="barcodeVerify" :warehouseId="form.warehouseId" :wmsNo="form.warehouseInNo" keep-bill-quantity difference-scene="saleInput" @save="saveBarcodeVerify"/>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>
import {ModalMixin} from "@/utils/ModalMixin";
import {mixin} from "@/utils/mixin";
import GoImportButton from "@/tools/GoImportButton";
import GoBarcodeImportButton from "@/tools/GoBarcodeImportButton";
import GoPrint from "@/components/tools/GoPrint";
import FlowableButton from "@/components/tools/FlowableButton";
import JSelect from "@/components/select/JSelect";
import GoEditTable from "@/components/tools/GoEditTable";
import OrderQtyTable from "@/components/tools/OrderQtyTable";
import AddGoodsToolBar from "@/components/tools/AddGoodsToolBar";
import BillState from "@/components/tools/BillState";
import {BillMixin} from "@/utils/BillMixin";
import SelectSaleOrder from "@/components/select/SelectSaleOrder";
import SelectWarehouse from "@/components/select/SelectWareshouse";
import SelectOrganization from "@/components/select/SelectOrganization";
import SelectOrderType from "@/components/select/SelectOrderType";
import {getSalePrice} from "@/api/api";
import DeptSaleInputInputQtyModal from "@/views/stock/in/modal/DeptSaleInputInputQtyModal";
import SelectSaleNotice from "@/components/select/SelectSaleNotice";
import SelectSaleOutput from "@/components/select/SelectSaleOutput";
import {getAction, postAction} from "@/api/manage";
import GoPopConfirm from "@/components/tools/GoPopConfirm";
import BarcodeCheckButton from "@/components/tools/BarcodeCheckButton";
import BillDetailModal from "@/components/tools/BillDetailModal";
import {checkPermission} from "@/utils/hasPermission";
import SelectGoods from "@/components/select/SelectGoods";
import ApiLogList from "@views/common/ApiLogList";
import WarehouseInBarcodeVerifyModal from "@views/order/base/modal/WarehouseInBarcodeVerifyModal.vue";

export default {
  name: "DeptSaleInputModal",
  components: {
    WarehouseInBarcodeVerifyModal,
    ApiLogList,
    SelectGoods,
    BillDetailModal,
    BarcodeCheckButton,
    GoPopConfirm,
    SelectSaleOutput,
    SelectSaleNotice,
    DeptSaleInputInputQtyModal,
    SelectOrderType,
    SelectOrganization,
    SelectWarehouse,
    SelectSaleOrder,
    BillState,
    AddGoodsToolBar,
    OrderQtyTable,
    GoEditTable,
    JSelect,
    FlowableButton,
    GoPrint,
    GoBarcodeImportButton,
    GoImportButton
  },
  mixins: [ModalMixin, mixin, BillMixin],
  data: function () {
    return {
      moduleKey: "10071",
      activeTab: "1",
      currentDetail: null,
      rules: {},
      goodsList: [],
      goodsColumns: [
        {
          title: '商品',
          dataIndex: 'goodsId',
          width: 150,
          canEdit: true,
          slotIgnore: false,
          validateRules: [{required: true, message: '商品不能为空'}],
          fixed: 'left',
          ellipsis: true,
          search: {
            field: 'goodsNo,goodsName',
            type: 'like'
          },
          scopedSlots: {customRender: 'goodsId'},
        },
        {
          title: '年份',
          dataIndex: 'age',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '季节',
          dataIndex: 'season',
          config: true,
          show: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '款型',
          dataIndex: 'style',
          config: true,
          show: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          config: true,
          show: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '尺码组',
          dataIndex: 'sizeGroupName',
          config: true,
          show: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '标准价',
          dataIndex: 'standardPrice',
          width: 70,
          type: 'Text',
          canEdit: false,
          slotIgnore: true,
          right: 'showStandardPrice'
        },
        {
          title: '折扣',
          dataIndex: 'discountRate',
          width: 70,
          type: 'Text',
          canEdit: true,
          slotIgnore: true,
          right: 'showSalePrice'
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          width: 70,
          type: 'Text',
          canEdit: true,
          slotIgnore: true,
          right: 'showSalePrice'
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          width: 70,
          type: 'Text',
          canEdit: false,
          sum: true,
        },
        {
          title: '金额',
          dataIndex: 'amt',
          width: 100,
          type: 'Text',
          canEdit: false,
          sum: true,
          right: 'showSalePrice'
        },
        {
          title: '说明',
          dataIndex: 'memo',
          width: 150,
          type: 'Text',
          canEdit: true,
          slotIgnore: true,
        }],
      uniBarcodeList: [],
      uniBarcodeColumns: [
        {
          title: '货号',
          dataIndex: 'goodsNo',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
          search: {
            field: 'goodsNo',
            type: 'like'
          },
        },
        {
          title: '货名',
          dataIndex: 'goodsName',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
          search: {
            field: 'goodsName',
            type: 'like'
          },
        },
        {
          title: '品牌',
          dataIndex: 'brand',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '商品类别',
          dataIndex: 'goodsType',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '单位',
          dataIndex: 'unit',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '年份',
          dataIndex: 'age',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '季节',
          dataIndex: 'season',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '系列',
          dataIndex: 'serail',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '款型',
          dataIndex: 'style',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '颜色',
          dataIndex: 'colorName',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '尺码',
          dataIndex: 'sizeName',
          show: true,
          config: true,
          width: 100,
          canEdit: false,
          slotIgnore: true,
        },
        {
          title: '条码',
          dataIndex: 'barcode',
          show: true,
          config: true,
          width: 150,
          canEdit: false,
          slotIgnore: true,
          search: {
            field: 'barcode',
            type: 'like'
          },
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          show: true,
          config: true,
          width: 150,
          canEdit: false,
          sum: true,
          slotIgnore: true,
        },
        {
          dataIndex: 'config',
          config: false,
          fixed: 'right',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
          },
          width: 28
        },
      ],
      url: {
        add: '/bill/deptSaleInput/add',
        edit: '/bill/deptSaleInput/edit',
        delete: "/bill/deptSaleInput/delete",
        submit: '/bill/deptSaleInput/submit',
        audit: '/bill/deptSaleInput/audit',
        listGoods: '/bill/deptSaleInput/listGoods',
        goodsDetail: '/bill/deptSaleInput/goodsDetail',
        exportDetail: '/sys/export/exportSaleInputDetail',
        unSubmit: '/bill/deptSaleInput/unSubmit',
        cancel: '/bill/deptSaleInput/cancel',
        listUniBarcode: '/bill/warehouseIn/listUniBarcode',
        saveBarcodeVerify: '/bill/deptSaleInput/saveBarcodeVerify',
        confirmBarcodeDifference: '/bill/deptSaleInput/confirmBarcodeDifference',
        listDetail: '/bill/saleInput/listDetail',
        view: '/bill/saleInput/view',
        pushToWms: '/bill/deptSaleInput/pushToWms',
        getDetail: '/bill/deptSaleInput/getDetail',
        pushExternal: '/bill/deptSaleInput/pushExternal',
        reEdit: '/bill/deptSaleInput/reEdit',
      }
    }
  },
  methods: {
    checkPermission,
    createDetail: function (item, detailItem) {
      let detail = {
        goodsId: item.goodsId,
        indexNo: item.indexNo,
        deliveryDate: item.deliveryDate,
        standardPrice: item.standardPrice,
        unitPrice: item.unitPrice,
        discountRate: item.discountRate,
        memo: item.memo
      }
      detail.colorId = detailItem.colorId
      detail.specId = detailItem.specId
      detail.sizeId = detailItem.sizeId
      detail.quantity = detailItem.quantity
      return detail
    },
    handleUpdateGoods: async function (detail) {
      let find = this.goodsList.find(item => {
        return detail.key === item.key
      })
      if (this.currentDetail.key !== detail.key) {
        this.currentDetail = {...detail}
      }
      if (find.detailList === undefined) {
        await this.setGoodsDetail(find)
      }
      this.$refs.goodsTable.selectColumn(find)
      let param = {
        goodsId: find.goodsId,
        orderOrganizationId: this.form.orderOrganizationId,
        orderWarehouseId: this.form.orderWarehouseId,
        data: find
      }
      this.$refs.inputQtyModal.inputQty(param)
    },
    handleRecordChange: function (record, field) {
      if (field === 'unitPrice') {
        record.amt = this.multi(record.quantity, record.unitPrice)
        record.discountRate = this.div(record.unitPrice, record.standardPrice)
      } else if (field === 'discountRate') {
        record.unitPrice = this.multi(record.standardPrice, record.discountRate)
        record.amt = this.multi(record.unitPrice, record.quantity)
      }
    },
    handleAddDetail: function (detailList) {
      for (let i = 0; i < detailList.length; i++) {
        let detail = detailList[i]
        detail.deliveryDate = null
        detail.editable = false
        detail.amt = this.formatAmt(this.multi(detail.unitPrice, detail.quantity))
        detail.indexNo = this.getMaxIndex(this.goodsList)
        this.$refs.goodsTable.addColumn(detail)
        if (i === detailList.length - 1) {
          this.$refs.goodsTable.selectColumn(detail)
          this.$refs.goodsTable.scrollInToView(detail)
          this.currentDetail = {...detail}
        }
      }
      this.$refs.goodsTable.sumFooter()
    },
    handleSelectGoods: function (goods) {
      let param = {
        goodsId: goods.goodsId,
        organizationId: this.form.orderOrganizationId,
        priceType: this.form.priceType
      }
      this.loading = true
      getSalePrice(param).then(res => {
        if (res.success) {
          this.$refs.goodsToolBar.updateGoods(res.result)
          let param = {
            goodsId: goods.goodsId,
            orderOrganizationId: this.form.orderOrganizationId,
            orderWarehouseId: this.form.orderWarehouseId,
            data: null
          }
          this.$refs.inputQtyModal.inputQty(param)
        } else {
          this.$message.error("取价格发生错误");
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleGetPrice: async function (goodsId) {
      let result = null
      await getSalePrice({goodsId, organizationId: this.form.orderOrganizationId, priceType: this.form.priceType}).then(res => {
        if (res.success) {
          result = res.result
        }
      })
      return result
    },
    queryWarehouseParam: function () {
      let param = {
        organizationId: this.form.orderOrganizationId,
      }
      return param
    },
    handleChangeOrderOrg: function () {
      this.form.orderWarehouseId = ''
    },
    // 返回历史条码加载结果，供编辑流程和扫描门禁等待。
    loadUniBarcode: function () {
      return this.loadBillUniBarcode({no: this.form.id, wmsNo: this.form.warehouseInNo})
    },
    handleBarcodeVerify: function () {
      this.loading = true
      getAction(this.url.getDetail, {id: this.form.id}).then(res => {
        let dataList = res.result
        this.$refs.barcodeVerify.view(dataList, this.form.id, 1)
      }).finally(res => {
        this.loading = false
      })
    },
    handleChangeGoods: function (data, record, field) {
      record.quantity = 0
      record.amt = 0
      record.property1 = data.property1
      record.property2 = data.property2
      record.property3 = data.property3
      record.property4 = data.property4
      record.property5 = data.property5
      record.property6 = data.property6
      record.property7 = data.property7
      record.property8 = data.property8
      record.property9 = data.property9
      record.property10 = data.property10
      record.deleteList = JSON.parse(JSON.stringify(record.detailList))
      record.detailList.length = 0
      record.sizeList = null
      record.retailPrice = data.retailPrice
      this.currentDetail = JSON.parse(JSON.stringify(record))
      if (data) {
        record.goodsId = data.id
        this.$refs.goodsTable.handleChange(data.id, record, field)
        this.handleUpdateGoods(this.currentDetail)
      } else {
        record.goodsId = null
        this.$refs.goodsTable.handleChange(null, record, field)
      }
    },
    handlePushToWms: function () {
      this.loading = true
      getAction(this.url.pushToWms, {id: this.form.id}).then(res => {
        if (res.success) {
          this.$message.success("操作成功")
          this.handleView(res.result)
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    saveBarcodeVerify: function (confirmData) {
      this.loading = true
      let success = false
      let action = confirmData && (confirmData.shortList.length > 0 || confirmData.overList.length > 0)
          ? postAction(this.url.confirmBarcodeDifference, {...confirmData, id: this.form.id})
          : getAction(this.url.saveBarcodeVerify, {id: this.form.id})
      action.then(res => {
        if (res.success) {
          success = true
          this.$message.success(res.message || "核对成功")
          this.handleView(res.result)
          this.$refs.barcodeVerify.visible = false
        } else {
          this.$message.error(res.message)
        }
      }).finally(res => {
        this.loading = false
        if (this.$refs.barcodeVerify) {
          this.$refs.barcodeVerify.finishDifferenceConfirm(success)
        }
      })
    },
    pushExternal: function () {
      this.loading = true
      getAction(this.url.pushExternal, {id: this.form.id}).then(res => {
        if (res.success) {
          this.$message.success("推送成功")
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    customStyle: function () {
      let bodyStyle = {...this.modalStyle}
      bodyStyle.maxHeight = this.modalHeight + "px"
      bodyStyle.height = this.modalHeight + "px";
      bodyStyle.padding = "4px"
      return bodyStyle
    },
    bottomHeight: function () {
      let height = 0
      if (this.disableSubmit || !this.checkPermission('DeptSaleInput:editDetail')) {
        height = this.modalHeight - 294
      } else {
        height = this.modalHeight - 376
      }
      if (height < 200) {
        return 200
      }
      return height
    }
  },
}
</script>
<style lang="less" scoped>
</style>
